import React from "react";
import { CpuIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/landing";
type HeroProps = {
  ctaRef: React.RefObject<HTMLDivElement>;
};
export function Hero({
  ctaRef
}: HeroProps) {
  return <header className="px-4 pb-14 pt-6 sm:pt-10" data-id="element-181" data-mp="hvh14jeva3z3">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-182" data-mp="hw8x3vcdm3pw">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-183" data-mp="mt8z9v63umbq">
          <span className="flex items-center gap-2" data-id="element-184" data-mp="quua7az2wqja">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand-700 text-white" data-id="element-185" data-mp="qt9gfnkl9bmh">
              <CpuIcon className="h-5 w-5" aria-hidden="true" data-id="element-186" data-mp="10lfixr8gvbfx" />
            </span>
            <span className="font-serif text-lg font-bold text-brand-800" data-id="element-187" data-mp="10njjbz75psbg">ECU Decision System™</span>
          </span>
        </div>

        <h1 className="mt-6 font-serif text-[2.1rem] font-extrabold leading-[1.08] text-ink sm:text-5xl lg:text-[4rem]" data-id="element-188" data-mp="1ajd4u82usw5d">
          Diagnose ECU problems & know your next step in{" "}
          <em className="font-black italic text-brand-600" data-id="element-189" data-mp="4optc945k57a">10 minutes or less</em>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-190" data-mp="4r2k9brw1pwh">
          Ever had an ECU sitting on your workbench and thought <strong className="text-ink" data-id="element-191" data-mp="3ru78tij7038w">“Where do I even start?”</strong>{" "}
          A practical visual system with <strong className="text-ink" data-id="element-192" data-mp="sd94qxii0y3l">6 premium volumes</strong>,{" "}
          <strong className="text-ink" data-id="element-193" data-mp="nepe4jsymy4w">5 professional bonuses</strong> and{" "}
          <strong className="text-ink" data-id="element-194" data-mp="iohequx00nvb">30+ decision protocols</strong>, checklists and workshop tools.
        </p>

        <img src={images.mockup} alt="ECU Decision System 6 volumes, 5 bonuses, decision maps and checklists" className="mt-6 w-full max-w-2xl sm:mt-8" data-id="element-195" data-mp="en5jo9vcvafq" />

        <div ref={ctaRef} className="mt-6 w-full" data-id="element-196" data-mp="16e3a17a92iy1">
          <CTAButton label="Get the ECU Decision System™" subtext="Instant download · One-time payment of USD $27 · Lifetime access · 7-day guarantee" data-id="element-197" data-mp="16ciilqj8fg4e" />
        </div>

        <div className="mt-8" data-id="element-198" data-mp="35kh3umkqg8uv">
          <Countdown data-id="element-199" data-mp="35muv0kcal0x5" />
        </div>
      </div>
    </header>;
}